export default "__VITE_ASSET__DJhjkaH0__"